import React from 'react';
import { TimelineDot } from '@material-ui/lab';
import {
  Icon,
  Typography,
  Card,
} from '@material-ui/core';
import {
  getColorForItem,
  getIconForItem,
} from './iconHelper';

import User from '../components/widgets/User';
import Property from '../components/widgets/Property';
import {
  primary,
  grey,
  success,
} from './brand-colors';
import { getCommentStringFromMentionString } from './mentions-helper';

export const getTimelineDot = (activity, statuses) => {
  let iconColor = grey.main;
  let icon = 'info';
  if (activity.type === 'comment') {
    icon = 'comment';
  } else if (activity.type === 'eventUpload') {
    icon = 'attach_file';
  } else if (activity.type === 'eventComplete') {
    iconColor = primary.main;
    icon = 'check_circle';
  } else if (activity.type === 'eventStart') {
    iconColor = success.main;
    icon = 'create_new_folder';
  } else if (activity.type === 'eventStatus') {
    const metadata = JSON.parse(activity.metadata);
    iconColor = getColorForItem(statuses, metadata.statusId);
    icon = getIconForItem(statuses, metadata.statusId);
  }

  return (
    <TimelineDot
      style={{
        color: iconColor,
        backgroundColor: '#F2F2F2',
      }}
    >
      <Icon>{icon}</Icon>
    </TimelineDot>
  );
};

export const getActivityEvent = ({
  activity,
  onEventClick,
  statuses,
  childComponent,
  classes,
}) => {
  const event = JSON.parse(activity.event);
  const foundStatus = statuses.find((status) => status.id === event.statusId) || { id: -1 };
  event.currentEventStatus = {
    id: activity.createddate,
    status: foundStatus,
  };
  return (
    <Card onClick={() => onEventClick(event.id)}>
      {
        childComponent
          ? <div style={{ padding: '0rem 1rem 1rem 1rem' }}>{childComponent}</div>
          : (
            <div className={classes.assignmentProperty}>
              <Property label="Assignment">
                {
                  event.statusAssignment
                    ? event.statusAssignment.split(/(?=@\[)/)
                      .map((user) => (
                        <User
                          key={user.auth0UserId}
                          chip
                          user={{ auth0UserId: user.match(/@\[.*\]\((.*)\)/)[1] }}
                        />
                      ))
                    : '-'
                  }
              </Property>
            </div>
          )
      }
    </Card>
  );
};

export const getActivityComment = (activity, classes) => {
  const metadata = JSON.parse(activity.metadata);
  let comment = '';
  if (activity.type === 'comment' && metadata.comment) {
    comment = metadata.comment;
  } else if (activity.type === 'eventComplete' && metadata.statusComment) {
    comment = metadata.statusComment;
  } else if (activity.type === 'eventStart' && metadata.statusComment) {
    comment = metadata.statusComment;
  } else if (activity.type === 'eventStatus' && metadata.statusComment) {
    comment = metadata.statusComment;
  } else {
    return '';
  }

  return (
    <div className={classes.commentContainer}>
      <Typography variant="body1" className={classes.commentText} component="div">
        {getCommentStringFromMentionString(comment)}
      </Typography>
    </div>
  );
};

export const buildHistoryItemObjects = (activities, statuses) => activities.map((activity) => {
  const historyItem = JSON.parse(activity.metadata);
  historyItem.type = activity.type;
  historyItem.event = activity.event;
  if (activity.type === 'eventComplete' || activity.type === 'eventStart' || activity.type === 'eventStatus') {
    historyItem.completeEvent = activity.type === 'eventComplete';
    historyItem.startEvent = activity.type === 'eventStart';
    historyItem.status = statuses.find((status) => status.id === historyItem.statusId) || { id: -1 };
  }
  if (activity.type === 'eventUpload') {
    historyItem.fileName = historyItem.fileName || historyItem.displayName;
  }

  return historyItem;
});
